import {
  Button,
  FormControl,
  InputLabel,
  Link,
  MenuItem,
  Modal,
  TextField,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { Box } from "@mui/system";
import React from "react";
import RKTextField from "../../../../../Supporting files/RKTextField/RKTextField";
import SelectDropdown from "../../../../../Supporting files/SelectDropdown/SelectDropdown";
import RemovePopup from "../../../../../Components/Common/CarForm/RemovePopup/RemovePopup";
import AddmemberPopup from "./AddmemberPopup/AddmemberPopup";
import Personaldetails from "../Personaldetails/Personaldetails";

function Familymember() {
  const label = { inputProps: { "aria-label": "Switch demo" } };
  const [addMemberStatus, setAddMemberStatus] = React.useState(false);
  const [annualIncome, setAnnualIncome] = React.useState<
    number | string | Array<number | string>
  >(300000);
  const [name, setName] = React.useState("");
  const [gender, setGender] = React.useState("");
  const [maritalStatus, setMaritalStatus] = React.useState("");
  const [relation, setRelation] = React.useState("");
  const [age, setAge] = React.useState("");
  const [dob, setDob] = React.useState<Date | null>(
    new Date("2014-08-18T21:11:54")
  );

  const handleChange = (event: SelectChangeEvent, attrName: string) => {
    if (attrName === "gender") {
      setGender(event.target.value as string);
    } else if (attrName === "maritalStatus") {
      setMaritalStatus(event.target.value as string);
    } else if (attrName === "relation") {
      setRelation(event.target.value as string);
    } else if (attrName === "age") {
      setAge(event.target.value as string);
    }
  };

  const handleChangeDate = (newValue: Date | null) => {
    setDob(newValue);
  };

  // const handleSliderChange = (event: Event, newValue: number | number[]) => {
  //   setAnnualIncome(newValue);
  // };
  let relation_data = [
    { key: "Brother", value: "Brother" },
    { key: "Sister", value: "Sister" },
  ];
  let age_data = [
    { key: "20 Years", value: "20 Years" },
    { key: "22 Years", value: "22 Years" },
    { key: "24 Years", value: "24 Years" },
    { key: "26 Years", value: "26 Years" },
    { key: "28 Years", value: "28 Years" },
  ];

  const updateMasterState = (attrName: any, value: string | boolean) => {
    attrName(value);
  };

  const [open, setOpen] = React.useState(false);
  const [editMember, setEditMember] = React.useState(false);
  const [remove, setRemove] = React.useState(false);
  const [kycdocs, setKycDocs] = React.useState(false);

  return (
    <Grid container spacing={0} className="familyMembers">
      <RemovePopup
        attrName={setRemove}
        open_status={remove}
        value_update={updateMasterState}
      />
      <Grid md={10} lg={7}>
        <Grid container alignItems="center" spacing={3}>
          <Grid xs={6}>
            <h3 className="mb-0">Family Member</h3>
          </Grid>
          <Grid xs={6} className="text-right">
            <Link
              className="greenBtn addfile"
              underline="none"
              onClick={() => {
                setOpen(true);
              }}
            >
              Add member
            </Link>
          </Grid>
          <Grid md={12}>
            <Box className="memberDetails">
              <span className="memberIcon">
                <img src="./images/profile_vector_icon.svg" alt="profile" />
              </span>
              <span className="memberName">
                <h6>Shivani Raghuvanshi</h6>
                <p>Wife, 30 years</p>
                <Link
                  underline="none"
                  onClick={() => {
                    setKycDocs(true);
                  }}
                >
                  Add KYC
                </Link>
                <Modal open={kycdocs} className="modalWrapper">
                  <Box className="modalInner">
                    <Grid container spacing={3}>
                      <Grid xs={12}>
                        <Link
                          className="close-button"
                          onClick={() => {
                            setKycDocs(false);
                          }}
                        />
                        <h5 className="popup-heading">Upload Documents</h5>
                      </Grid>
                    </Grid>
                    <Grid container justifyContent="center">
                      <Grid xs={10} className="inputField uploadFile mb-5">
                        <TextField
                          fullWidth
                          id="outlined-basic"
                          label="Upload Document"
                          className="textarea"
                        />
                      </Grid>
                      <Grid xs={2}>
                        <Button className="browsebtn">Browse</Button>
                      </Grid>
                      <Grid
                        xs={12}
                        className="ctaBtn"
                        style={{ textAlign: "center" }}
                      >
                        <Button className="submitBtn">Submit Details</Button>
                      </Grid>
                    </Grid>
                  </Box>
                </Modal>
              </span>
              <span className="actionBtns">
                <Link
                  className="redBtn delete"
                  underline="none"
                  onClick={() => {
                    setRemove(true);
                  }}
                >
                  Remove
                </Link>
                <Link
                  className="blueBtn edit"
                  underline="none"
                  onClick={() => {
                    setOpen(true);
                  }}
                >
                  Edit
                </Link>
                {/* <Modal open={editMember} className="modalWrapper">
                  <Box className="modalInner">
                    <Grid container spacing={3}>
                      <Grid xs={12}>
                        <Link
                          
                          className="close-button"
                          onClick={() => {
                            setEditMember(false);
                          }}
                        />
                        <h5 className="popup-heading">Edit Member Details</h5>
                      </Grid>
                    </Grid>
                    <Grid container spacing={3} justifyContent="center">
                      <Grid xs={12} className="inputField">
                        <RKTextField 
                          title='Name'
                          value={name}
                          attrName={setName}
                          value_update={updateMasterState}
                        />
                      </Grid>
                      <Grid xs={6} className="inputField">
                        <SelectDropdown 
                            title="Relationship"
                            value={relation}
                            attrName={setRelation}
                            value_update={updateMasterState}
                            dropdown_data={relation_data}
                        />
                      </Grid>
                      <Grid xs={6} className="inputField">
                        <SelectDropdown 
                            title="Age"
                            value={age}
                            attrName={setAge}
                            value_update={updateMasterState}
                            dropdown_data={age_data}
                        />
                      </Grid>
                      <Grid
                        xs={12}
                        className="ctaBtn"
                        style={{textAlign: "center"}}
                      >
                        <Button className="submitBtn">
                          Submit Details
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </Modal> */}
              </span>
            </Box>
            <Box className="memberDetails">
              <span className="memberIcon">
                <img src="./images/profile_vector_icon.svg" alt="profile" />
              </span>
              <span className="memberName">
                <h6>Devansh Raghuvanshi</h6>
                <p>Son, 30 years</p>
                <Link underline="none">Add KYC</Link>
              </span>
              <span className="actionBtns">
                <Link
                  className="redBtn delete"
                  underline="none"
                  onClick={() => {
                    setRemove(true);
                  }}
                >
                  Remove
                </Link>

                <Link
                  className="blueBtn edit"
                  underline="none"
                  onClick={() => {
                    setOpen(true);
                  }}
                >
                  Edit
                </Link>
                {/* <Modal open={editMember} className="modalWrapper">
                  <Box className="modalInner">
                    <Grid container spacing={3}>
                      <Grid xs={12}>
                        <Link
                          
                          className="close-button"
                          onClick={() => {
                            setEditMember(false);
                          }}
                        />
                        <h5 className="popup-heading">Edit Member Details</h5>
                      </Grid>
                    </Grid>
                    <Grid container spacing={3} justifyContent="center">
                      <Grid xs={12} className="inputField">
                        <RKTextField 
                          title='Name'
                          value={name}
                          attrName={setName}
                          value_update={updateMasterState}
                        />
                      </Grid>
                      <Grid xs={6} className="inputField">
                        <SelectDropdown 
                            title="Relationship"
                            value={relation}
                            attrName={setRelation}
                            value_update={updateMasterState}
                            dropdown_data={relation_data}
                        />
                      </Grid>
                      <Grid xs={6} className="inputField">
                        <SelectDropdown 
                            title="Age"
                            value={age}
                            attrName={setAge}
                            value_update={updateMasterState}
                            dropdown_data={age_data}
                        />
                      </Grid>
                      <Grid
                        xs={12}
                        className="ctaBtn"
                        style={{textAlign: "center"}}
                      >
                        <Button className="submitBtn">
                          Submit Details
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </Modal> */}
              </span>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Familymember;
